// extracted by mini-css-extract-plugin
module.exports = {"overlay":"WarningModal_overlay__2crlv","inputContainer":"WarningModal_inputContainer__3ugcl","feedback":"WarningModal_feedback__1xlP5","text":"WarningModal_text__31Sir"};